// src/features/bootstrap/logic.ts
// Status → badge variant mapping and small helpers for the bootstrap admin console.
// See docs/ux/bootstrap-ia.md.

import type { BootstrapStatus, WizardStepStatus, BootstrapStepStatus } from '@core/types/bootstrap';

export function enumSuffix(value: string | undefined, prefix: string): string {
  if (!value) return 'unspecified';
  return value.startsWith(prefix) ? value.slice(prefix.length).toLowerCase() : value.toLowerCase();
}

export function bootstrapStatusVariant(status?: BootstrapStatus): string {
  switch (status) {
    case 'BOOTSTRAP_STATUS_COMPLETED': return 'success';
    case 'BOOTSTRAP_STATUS_EXECUTING': return 'info';
    case 'BOOTSTRAP_STATUS_IN_PROGRESS': return 'warning';
    case 'BOOTSTRAP_STATUS_FAILED': return 'error';
    default: return 'default';
  }
}

export function wizardStepVariant(status?: WizardStepStatus): string {
  switch (status) {
    case 'WIZARD_STEP_STATUS_COMPLETED': return 'success';
    case 'WIZARD_STEP_STATUS_CURRENT': return 'info';
    case 'WIZARD_STEP_STATUS_ERROR': return 'error';
    default: return 'default';
  }
}

export function executionStepVariant(status?: BootstrapStepStatus): string {
  switch (status) {
    case 'BOOTSTRAP_STEP_STATUS_COMPLETED': return 'success';
    case 'BOOTSTRAP_STEP_STATUS_IN_PROGRESS': return 'info';
    case 'BOOTSTRAP_STEP_STATUS_FAILED': return 'error';
    case 'BOOTSTRAP_STEP_STATUS_AWAITING_CONFIRMATION': return 'warning';
    case 'BOOTSTRAP_STEP_STATUS_SKIPPED': return 'default';
    default: return 'default';
  }
}

export const STEP_IDS = ['mode', 'identity', 'vault', 'admin', 'products', 'security'] as const;
export type StepId = typeof STEP_IDS[number];
